import { render, staticRenderFns } from "./courseLeadersFiltersList.vue?vue&type=template&id=8760b2bc&scoped=true&lang=pug"
import script from "./courseLeadersFiltersList.vue?vue&type=script&lang=js"
export * from "./courseLeadersFiltersList.vue?vue&type=script&lang=js"
import style0 from "./courseLeadersFiltersList.vue?vue&type=style&index=0&id=8760b2bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8760b2bc",
  null
  
)

export default component.exports